// Buffered because the host can push an action before the page that acts on it has mounted.

interface Handoff<T> {
  deliver: (value: T) => void;
  onDeliver: (handler: (value: T) => void) => () => void;
}

export const createHandoff = <T>(): Handoff<T> => {
  let handler: ((value: T) => void) | null = null;
  // Boxed so a legitimately null payload is still distinguishable from an empty buffer.
  let buffered: { value: T } | null = null;

  return {
    deliver: (value) => {
      if (handler) handler(value);
      else buffered = { value };
    },
    onDeliver: (next) => {
      if (handler && import.meta.env.DEV) {
        console.warn('[embed] handoff handler replaced; the previous one will stop receiving.');
      }
      handler = next;
      if (buffered) {
        const { value } = buffered;
        buffered = null;
        next(value);
      }
      return () => {
        if (handler === next) handler = null;
      };
    },
  };
};
